"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var global_styles_1 = require("../../Global/global.styles");
var TableHeader = function (props) {
    var column = props.column, rows = props.rows;
    return (react_1.default.createElement(global_styles_1.FlexContainer, null,
        react_1.default.createElement(storm_ui_1.Text, { type: 'h5', textColor: rows.length === 0 ? 'tertiary' : 'base' }, column.id)));
};
exports.TableHeader = TableHeader;
